/* eslint-disable */
import { APP_DATA_FETCH_ERR, APP_DATA_FETCH_SUCCESS } from './actions';

const initialState = {
  app: [],
  error: null,
};

const appReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case APP_DATA_FETCH_SUCCESS:
      return {
        ...state,
        app: data,
        error: null,
      };
    case APP_DATA_FETCH_ERR:
      return {
        ...state,
        error: err,
      };
    default:
      return state;
  }
};

export { appReducer };

